import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import { reactQueryClient } from '@/utils/reactQueryClient';
import { scribeHttpV2 } from '@/utils/scribeHTTP';
import type { ChatListResponse } from '@heidi/session/contracts';
import { useQuery } from '@tanstack/react-query';

export const GET_SAVED_CHATS = 'get_saved_chats';

export const invalidateSavedChats = () => {
  return reactQueryClient.invalidateQueries({ queryKey: [GET_SAVED_CHATS] });
};

export function useQuerySavedChats(page = 1, pageSize = 100) {
  const { isAuthenticated } = useIsAuthenticated();

  // Only fetch saved chats for authenticated users — anonymous/temp users cannot save chats
  return useQuery<ChatListResponse>({
    queryKey: [GET_SAVED_CHATS, page, pageSize],
    enabled: isAuthenticated,
    queryFn: async () => {
      const { data } = await scribeHttpV2.get<ChatListResponse>('/chat/chats/saved', {
        params: { page, page_size: pageSize, exclude_workflow_runs: true },
      });
      return data;
    },
  });
}
